import { useEffect, useState } from 'react';
import axios from 'axios';

const useUserMap = () => {
  const [userMap, setUserMap] = useState(new Map());

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get('/api/EditUser');

        const users = res.data || [];
        const map = new Map();
        users.forEach((u) => map.set(u.id, u.name));
        setUserMap(map);
      } catch (err) {
        console.error('Failed to fetch users', err);
      }
    };

    fetchUsers();
  }, []);

  return userMap;
};

export default useUserMap;
